<template>
    <div>
      <el-dialog
          title="Asset details"
          :visible.sync="show_details"
      >
        <div>
          <AssetDetails :extent_id="extentId" :asset_id="assetId">

          </AssetDetails>
        </div>
      </el-dialog>
        <el-table
                :data="tableData"
                border
                @sort-change="sortChange"
        >
          <el-table-column
              v-for="column in tableDefinitionFull"
              v-bind:label = column.label
              v-bind:prop = column.prop
              v-bind:width = column.width
              v-bind:show_color = column.show_color
              sortable = 'custom'
          >
            <template slot-scope="scope">
              <div v-if="column.type==='url'">
                <a :href="scope.row[column.prop]" target="_blank">{{scope.row[column.prop]}}</a>
              </div>
              <div v-else-if="column.type==='edit_button'">
                <el-button
                    @click="activate_details(scope.row.processed_asset_id)"
                    icon="el-icon-edit"
                    size="small"
                ></el-button>
              </div>
              <div v-else>
                <div v-if="column.show_color" :style="scope.row['style']">
                  {{scope.row[column.prop]}}
                </div>
                <div v-else>
                  {{scope.row[column.prop]}}
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div v-if="is_loading" style="text-align:center;padding:5px;background-color:darkolivegreen;color:white;">Loading more rows</div>
        <div v-else-if="scroll_count_since_reset>=max_scroll_without_reset" style="text-align:center;padding:5px;background-color:darkgoldenrod;color:white;">Scroll up then down to get more rows</div>
        <div v-else-if="this.page===this.last_page" style="text-align:center;padding:5px;background-color:gray;color:white;">End of data</div>
    </div>
    
</template>

<script>
    export default {
        name: "TableView",
        props: ['endPoint','tableDefinition','extentId','colors','colored_prop','additional_filters'],
        data() {
            return {
                tableData: [],
                page: 0,
                last_page: 1000,
                is_loading: false,
                have_new_endpoint: false,
                show_bleeding_edge: false,
                last_load: null,
                show_details: false,
                assetId: null,
                scroll_count_since_reset: 0,
                max_scroll_without_reset: 5
            }
        },
        watch: {
            endPoint: function (val) {
              console.log('got endPoint change in TableView: ' + val)
                    this.page = 0
                    this.tableData = []
              if (val) {
                this.have_new_endpoint = true
                console.log('in TableView, about to fetch data')
                this.fetchData()
              }
            },
            colors: function() {
              this.loadColors()
            },
          fields: function() {
              this.loadColors()
          },
          colored_prop: function() {
            this.loadColors()
          }
        },
        computed: {
            tableDefinitionFull: function() {
              let def = this.tableDefinition
              def.push({
                    'prop': '',
                    'label': '',
                    'type': 'edit_button',
                    'width': '70'
                  })
              console.log(def)
              return def
            }
        },
        mounted() {
            if (chimera.permissions.includes('BLEEDING_EDGE')) this.show_bleeding_edge = true
            this.loadColors()
            this.fetchData()

            window.onscroll = (event) => {
                if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
                    // you're at the bottom of the page
                  if (this.scroll_count_since_reset<=this.max_scroll_without_reset) {
                    this.scroll_count_since_reset++
                    this.fetchData();
                  }
                } else {
                    if(this.scroll_count_since_reset>=this.max_scroll_without_reset) {
                      this.scroll_count_since_reset = 0
                    }
                }
            };
        },
        methods: {
          sortChange(payload) {
            this.$emit('sortChange',payload)

          },
          computeDefinition() {

          },
          loadColorsIncremental(newTableData) {
            if (!newTableData) {
              console.log('do not have newTableData, so not loading colors')
              return;
            }
            newTableData.forEach(x => {
              let color = this.colors[x[this.colored_prop]]
              if (color) {
                x.style = 'border-bottom: solid 4px ' + color
              } else {
                x.style=''
              }
            })
            return(newTableData)
          },
          loadColors() {
            this.tableData = this.loadColorsIncremental(this.tableData)
            this.tableDefinitionFull.forEach(x => {
              x.prop===this.colored_prop ? x.show_color = true : x.show_color = false
            })
          },
          activate_details(assetId) {
            this.show_details = true
            this.assetId = assetId
          },
            fetchData() {
                if (!this.last_load) this.last_load = new Date()
                if (!this.have_new_endpoint) { // if we have a new endpoint, we're going to request it even if we're already loading something else
                  if (this.getIsLoading()) {
                    return;
                  }
                  if (this.page === this.last_page) {
                    this.setIsLoading(false)
                    return;
                  }
                } else {
                  this.page = 0
                }
                this.setIsLoading(true)
                let full_url = this.endPoint + '&page=' + (this.page+1)
                axios.post(full_url, {
                      additional_filters: this.additional_filters
                }).then(response => {
                      if (this.have_new_endpoint) {
                        this.tableData = []
                      }
                      this.have_new_endpoint = false
                      let row_num = response.data.from
                      let new_rows = response.data.data
                      new_rows.forEach(x => {x.row_num = row_num++})
                      new_rows = this.loadColorsIncremental(new_rows)
                      this.tableData = this.tableData.concat(new_rows)
                      this.page = response.data.current_page
                      this.last_page = response.data.last_page
                      this.setIsLoading(false)
                    })
                    .catch(error => {
                      console.log('oops getting table data')
                      this.setIsLoading(false)
                      console.log('set loading to false, on failure')

                    })

            },
          // Created these two functions so could hook into setting/getting values to
          // debug race conditions
          getIsLoading() {
            return this.is_loading
          },
          setIsLoading(value) {
            this.is_loading = value
          }
        }
    }
</script>

<style scoped>

</style>